import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FaqModel } from '../../../models/faq.model';
import { EtdService } from '../../../services/etd.service';

@Component({
  selector: 'app-new-faq',
  templateUrl: './new-faq.component.html',
  styleUrls: ['./new-faq.component.scss'],
})
export class NewFaqComponent implements OnInit {
  faq: FaqModel = new FaqModel();

  @Output() onSubmitEvent: EventEmitter<boolean> = new EventEmitter();
  @Input() editedFaq: FaqModel;
  @Input() isEditing: boolean;

  constructor(
    private _etdService: EtdService,
  ) {
  }

  ngOnInit() {
    this.faq = new FaqModel();
    if (this.isEditing) {
      this.faq = this.editedFaq;
    }
  }

  onFaqSubmit() {
    this.faq.system = 'etd';
    if (this.isEditing) {
      this._etdService
        .updateFaq(this.faq)
        .subscribe(() => {
          this.onSubmitEvent.emit(true);
        }, () => {
          this.onSubmitEvent.emit(false);
        });
    } else {
      this._etdService
        .createFaq(this.faq)
        .subscribe(() => {
          this.onSubmitEvent.emit(true);
        }, () => {
          this.onSubmitEvent.emit(false);
        });
    }
  }

}
